import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'
import ProductsLong from './ProductsLong.jsx'

import { translate } from 'react-i18next';

var FiberPreOrder = React.createClass({


  getInitialState() {

    this.state = {
        email: '',
        emailError: false
      };

    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
    window.scrollTo(0, 0);
    document.body.classList.add('long-scroll');

    const emailCookie = this.getCookieValue("SESSemail");

    if (emailCookie != '') {
      this.setState({'email': emailCookie});
    }
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  handleChange(event) {
    this.setState({'email': event.target.value});
  },

  backToStepOne() {
    AvailabilityActions.backToStepOne();
  },

  selectProduct(product,collectEmail) {
    let domain = (window.cookie_domain ? window.cookie_domain : 'sonic.com');
    let select_to_signup = true;

    const emailAddress = this.state.email;

      if (collectEmail && !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(emailAddress)) {
    this.setState({'emailError':true});
    event.preventDefault();
    return;
    }

    if (collectEmail) {
    document.cookie = "SESSemail="+emailAddress+"; domain="+domain+"; path=/;";
    }

    if(select_to_signup) {
        var form = document.createElement('form');
        form.method = 'POST';
        form.action = this.state.store.get('signup_submit_target');

        var inputs = [
            ['referral_code', this.state.store.get('referralCode')],
            ['coupon_code', (product.promo && product.promo.code ? product.promo.code : '')],
            ['prequal_key', this.state.store.get('prequal_tracking_key')],
            ['product_key', product.product_key],
            ['coupon_history', (window.coupon_history ? window.coupon_history : []) ],
            ['sso_user', this.state.store.get('sso_user')],
            ['sonic_elq_customerID', this.state.store.get('sonic_elq_customerID')],
            ['emailAddress', emailAddress],
            ['page_source','preorder'],
        ];
        inputs.forEach(function(v) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = v[0];
            input.value = v[1];
            form.append(input);
        })

        document.body.append(form);
        form.submit();
        AvailabilityActions.placeOrder();
    }

    AvailabilityActions.selectProduct(product);
  },

  getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  },

  render() {
      const { t, show_voice_only } = this.props;
      var store = this.state.store;
      var products = store.get('products').toJS();
      let product = [];
      let coupon_banner = '';
      let otherProducts = false;
      products.forEach(item=>{
        if (item.product_key == 'fusion_fiber_preorder'){
          product = item;
        } else {
          otherProducts = true;
        }
      })

      var has_term = (product.technology == 'ftth' ? false : true);

      var displayPrice = parseFloat(product.mrc);

      let productRegularPrice = parseFloat(product.mrc);
      if(product.show_mrc_and_extra_fees_as_flat_rate) {
          let extraFeesTotal = product.extra_fees.reduce(function(carry, fee) {
              var feePrice = parseFloat(fee[1]);
              if(feePrice < 0) {
                  return carry;
              }
              carry += feePrice;
              return carry;
          }, 0.00);
          displayPrice += extraFeesTotal;
          productRegularPrice += extraFeesTotal;
      }
      var display_promo_amount = 0;
      var display_promo_duration = 0;

      if (product.promo && product.promo.hasOwnProperty('discount duration')) {
        display_promo_duration = product.promo['discount duration'];
      }
      var banner_addition = '';
      var promo_amount = 0;

      if(product.promo && product.promo.coupon_type_id && (product.promo.coupon_type_id == 38 || product.promo.coupon_type_id == 47)) {
          banner_addition = <div>Save $12 for 6 months on Whole-Home WiFi</div>;
      }
      if(product && product.promo) {
        promo_amount = product.promo['discount amount'];
      }

      if(product.promo && product.promo['coupon type'] && product.promo['coupon type'] == 'free month') {
        coupon_banner = product.promo['description display'];
      }

      let ineligible_coupon_text = "";
      if (product.og_coupon && product.og_coupon.coupon_type_id == 52) {
          ineligible_coupon_text = product.og_coupon.txt_ineligible;
      }

      let prequal_key = '';
      if(store.get('sso_user')) {
        prequal_key = <div>Prequal Key: {store.get('async_id')}</div>
      }

      if(product && product.promo) {
        promo_amount = product.promo['discount amount'];

        if (typeof product.promo['term_length'] !== 'undefined' && product.promo['term_length'] > 0) {
            has_term = true;
        }

        // all X month free promos under 1 year should show 10 off the display price
        if(promo_amount == 'free' || promo_amount == '6free' || promo_amount == '4free' || promo_amount == '3free' || promo_amount == '2free') {
            promo_amount = 10;
            display_promo_duration = 12;
        }
        else if(promo_amount == '12free') {
            promo_amount = 0;
            display_promo_duration = 12;
        } else {
            promo_amount = parseFloat(promo_amount);
        }
      }

      displayPrice =  Number(displayPrice - promo_amount).toFixed(2).replace('.00', '');
      productRegularPrice =  Number(productRegularPrice).toFixed(2).replace('.00', '');
      display_promo_amount = Number(promo_amount).toFixed(2).replace('.00', '');
      var qual_addr = store.get('qualified_address').toJS();
      var postal = store.get('postal_address').toJS();

      if(qual_addr.unit) {
        qual_addr.address = qual_addr.address + ', ' + qual_addr.unit;
      } else if (qual_addr.LocationValue1){
          qual_addr.address = (qual_addr.LocationDesignator1 ? qual_addr.address + ', ' + qual_addr.LocationDesignator1 + ' '+ qual_addr.LocationValue1 : qual_addr.address + ', ' + qual_addr.LocationValue1);
      }

      const currentYear = new Date().getFullYear();
      const yearsInBusiness = currentYear - 1994;

      let collectEmail = false; // turn to false for production.
      if (!store.get('sso_user')) {
        collectEmail = true;
      }

    return (
<div>
<div className="snc-signup-fixed-cta">
  <div className="container">
    <div className="cta-bundle">
    {( collectEmail ? '':
      <div>
        <a className="snc-btn snc-btn--sm" onClick={this.selectProduct.bind(null, product,collectEmail)} >{t('common:fiberPreOrder.preorder_now')}</a>
      </div>
    )}
    </div>
  </div>
</div>

<div className="snc-section--signup-offer">
  <div className="container">
    {(product.promo && display_promo_amount && display_promo_amount != 0
        ? <p className="offer">
        <span className="offer__special">Save ${Math.round(display_promo_amount)} for 12 months </span>
        <span className="offer__regular">({ ( t('common:regular_price').replace('{price}', productRegularPrice) )})</span>
        </p>
        : ""
    )}
    <p className="coupon">
      <span className="coupon__detail">{( coupon_banner )}</span>
    </p>
  </div>
</div>

<div className="snc-section--signup-preorder-hero">
  <div className="snc-section-inner">
    <div className="container">
      <div className="content">
        {(ineligible_coupon_text
            ? <span>
                <h1 className="ineligible">{(ineligible_coupon_text)}</h1>
                <div className="result">However, you're eligible for Sonic Fiber based on your location.</div>
              </span>
            : <span>
                <h1>Great News!</h1>
                <div className="result">You're eligible for Sonic Fiber.</div>
              </span>
        )}
        {/* postal_address isn't available for fusion fiber, but be ready if it is addded. */}
        <div className="address">{t('common:we_found_addr')} <span className="address-only">{qual_addr.address}, {postal.city ? postal.city : ''} {qual_addr.state} {qual_addr.zip}</span>, Residential (<a onClick={this.backToStepOne}>{t('common:fiberOnly.change_address')}</a>)</div>
        { prequal_key }
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-price">
  <div className="container">
    <h2>{t('common:fiberPreOrder.fastest_affordable')}</h2>
    <div className="service-price-wrapper">
      <h3>
        <span className="lg">1 </span><span>Gigabit</span>
        <span> at </span>
        <span className="lg">${displayPrice}</span><span>/mo</span>
      </h3>
      <span className="tax-note">{t('common:fiberOnly.tax_note')}</span>
    </div>
    {( collectEmail ? '':
    <div className="text-center">
      <a className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>{t('common:fiberPreOrder.preorder_now')}</a>
    </div>
    )}
  </div>
</div>
{( !collectEmail ? '':
<div className="snc-section--signup-contact">
  <div className="container">
    <div className={this.state.emailError ? 'snc-contact-cta has-error': 'snc-contact-cta'}>
      <h2>Enter your email address to request fiber now.</h2>
      <div className="form-group">
        <input type="email" aria-label="Email Address" placeholder="Email Address" className="form-control" name="email" value={this.state.email} onChange={this.handleChange}/>
      </div>
      {(!this.state.emailError ? '':
      <span className="help-block">Please enter valid Email Address</span>
      )}
      <div className="text-center">
        <button className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>Request Fiber Now</button>
      </div>
    </div>
  </div>
</div>
)}

<div className="snc-section--signup-preorder-process">
  <div className="container">
    <h2>{t('common:fiberPreOrder.how_it_works')}</h2>
    <div className="how-it-works">
      <div className="how-it-works-h">
        <img src="http://sonic.com/sites/default/files/how-it-works-horizontal-4.svg" alt="How it works" />
      </div>
      <div className="how-it-works-v">
        <img src="http://sonic.com/sites/default/files/how-it-works-vertical-4.svg" alt="How it works" />
      </div>
      <ol>
        <li>{t('common:fiberPreOrder.pre_order_bullet')}</li>
        <li>{t('common:fiberPreOrder.sign_up_bullet')}</li>
        <li>{t('common:fiberPreOrder.receive_bullet')}</li>
        <li>{t('common:fiberPreOrder.schedule_bullet')}</li>
      </ol>
    </div>
  </div>
</div>

<div className="snc-section--signup-speed snc-section-theme--gray">
  <div className="container">
    <h2>{t('common:fiberPreOrder.what_can_you')}</h2>
    <div className="row">
      <div className="col-sm-6">
        <img src="http://sonic.com/sites/default/files/upload-v2.svg" alt="Upload" />
      </div>
      <div className="col-sm-6">
        <img src="http://sonic.com/sites/default/files/download-v2.svg" alt="Download" />
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-fiber">
  <div className="container">
    <h2>{t('common:fiberOnly.why_sonic')}</h2>
    <div className="row">
      <div className="col-sm-4">
        <h3>{t('common:fiberOnly.browse_game')}</h3>
        <p>{t('common:fiberOnly.ultra_fast')}</p>
      </div>
      <div className="col-sm-4">
        <h3>{t('common:fiberOnly.more_devices')}</h3>
        <p>{t('common:fiberOnly.connect_many')}</p>
      </div>
      <div className="col-sm-4">
        <h3>{t('common:fiberOnly.ultra_up_down')}</h3>
        <p>{t('common:fiberOnly.whether_you')}</p>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-cutcord">
  <div className="container">
    <h2>{t('common:fiberOnly.cut_cord')}</h2>
    <p>{t('common:fiberOnly.cut_cord_blob')}</p>
    <p>
      <span className="strike">{t('common:fiberOnly.dvr_fees')}</span>
      <span>•</span>
      <span className="strike">{t('common:fiberOnly.hd_fees')}</span>
      <span>•</span>
      <span className="strike">{t('common:fiberOnly.rental_box_fees')}</span>
      <span>•</span>
      <span className="strike">{t('common:fiberOnly.cancellation_fees')}</span>
      <span>•</span>
      <span className="strike">{t('common:fiberOnly.sports_fees')}</span>
      <span>•</span>
      <span className="strike">{t('common:fiberOnly.local_fees')}</span>
    </p>
  </div>
</div>

<div className="snc-section--signup-wifi-v2">
  <div className="container">
    <div className="row">
      <div className="col-sm-6">
        <div className="content">
          <h2>{t('common:fiberOnly.whole_home')}</h2>
          <p>{t('common:fiberOnly.whole_home_blob')}</p>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="graphic">
          <video
          src="https://www.sonic.com/sites/default/files/eero.mp4"
          poster="http://sonic.com/sites/default/files/2gig-eero.png"
          type="video/mp4"
          preload="auto"
          autoplay
          loop
          muted
          playsinline
          ></video>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-customers">
  <div className="container">
    <h2>{t('common:fiberPreOrder.cust_say')}</h2>
    <div className="row">
      <div className="col-sm-4">
        <div className="quote">
          <p>{t('common:fiberPreOrder.cust_one')}</p>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="quote">
          <p>{t('common:fiberPreOrder.cust_two')}</p>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="quote">
          <p>{t('common:fiberPreOrder.cust_three')}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--features snc-section-theme--white">
  <div className="container-fluid">
    <div className="row">
      <div className="col-xs-10 col-xs-offset-1 col-sm-3 col-sm-offset-0">
        <h4>{t('common:fiberOnly.service_features')}<span className="snc-period">.</span></h4>
      </div>
      <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-1">
        <div className="row">
          <div className="col-xs-6 col-sm-5">
            <p>{t('common:fiberOnly.ser_feat_1')}</p>
            <p>{t('common:fiberOnly.ser_feat_2')}</p>
            <p>{t('common:fiberOnly.ser_feat_3')}</p>
            <p>{t('common:fiberOnly.ser_feat_4')}</p>
            <p>{t('common:fiberOnly.ser_feat_5')}</p>
          </div>
          <div className="col-xs-6 col-sm-5 col-sm-offset-2">
            <p>{t('common:fiberOnly.ser_feat_6')}</p>
            <p>{t('common:fiberOnly.ser_feat_7')}</p>
            <p>{t('common:fiberOnly.ser_feat_8')}</p>
            <p>{t('common:fiberOnly.ser_feat_9')}</p>
            <p>{t('common:fiberOnly.ser_feat_10')}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--values snc-section-theme--gray">
  <div className="container-fluid">
    <div className="snc-section-values-row-1">
      <div className="row">
        <div className="col-xs-10 col-xs-offset-1 col-sm-3 col-sm-offset-0">
          <h4>{t('common:fiberOnly.diff_kinda')}<span className="snc-period">.</span></h4>
        </div>
        <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-1">
          <div className="row">
            <div className="col-xs-12 col-sm-5">
              <h5>{t('common:fiberOnly.lead_cust')}</h5>
              <hr className="snc-separator" />
              <p>{t('common:fiberOnly.lead_cust_blob')}</p>
            </div>
            <div className="col-xs-12 col-sm-5 col-sm-offset-2">
              <h5>{t('common:fiberOnly.int_integ')}</h5>
              <hr className="snc-separator" />
              <p>{t('common:fiberOnly.int_integ_blob')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-4">
        <h5>{t('common:fiberOnly.sup_comm')}</h5>
        <hr className="snc-separator" />
        <p>{t('common:fiberOnly.sup_comm_blob_a')} {yearsInBusiness} {t('common:fiberOnly.sup_comm_blob_b')}</p>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-cta">
  <div className="container">
  {( collectEmail ? '':
    <div className="text-center">
      <a className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>{t('common:fiberPreOrder.preorder_now')}</a>
    </div>
  )}
  {( !collectEmail ? '':
<div className="snc-section--signup-contact">
  <div className="container">
    <div className={this.state.emailError ? 'snc-contact-cta has-error': 'snc-contact-cta'}>
      <h2>Enter your email address to request fiber now.</h2>
      <div className="form-group">
        <input type="email" aria-label="Email Address" placeholder="Email Address" className="form-control" name="email" value={this.state.email} onChange={this.handleChange}/>
      </div>
      {(!this.state.emailError ? '':
      <span className="help-block">Please enter valid Email Address</span>
      )}
      <div className="text-center">
        <button className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>Request Fiber Now</button>
      </div>
    </div>
  </div>
</div>
)}

  </div>
</div>

      </div>
    );
  }
});

export default  translate('common', { wait: true })(FiberPreOrder);